import * as lexStateMaintainActionType from '../actionsType/LexStateMaintain.actionType';

const initialState = {
    mainState: false,
    index: -1,
    blockExpand: false,
    trackingState: false,
    loginPanel: false
};

export function lexStateMaintainReducer(state = initialState, action) {
    switch (action.type) {
        case lexStateMaintainActionType.SET_EXPAND_LEX_STATE:
            return {...state, mainState: action.payload};
        case lexStateMaintainActionType.SET_EXPAND_INDEX:
            return {...state, index: action.payload};
        case lexStateMaintainActionType.SET_BLOCK_EXPAND:
            return {...state, blockExpand: action.payload};
        case lexStateMaintainActionType.SET_TRACKING_STATE:
            return {...state, trackingState: action.payload};
        case lexStateMaintainActionType.SET_LOGIN_MODAL:
            return {...state, loginPanel: action.payload};
        default:
            return state;
    }
}
